import Aos from "aos";
import React, { useState, useEffect } from "react";

import MintForm from "./MintForm";
import img from "../../assets/hipDude.png";
import bg from "../../assets/mintBG.png";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import StartMinting from "./StartMinting";
import PresaleForm from "./PresaleForm";
import Congrats from "./Congrats";
import PresaleCountdown from "./PresaleCountdown";
function SpaceshipMint() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  });
  const [showMintForm, setShowMintForm] = useState(false);
  const [showCongratsForm, setShowCongratsForm] = useState(false);
  const [showFinish, setFinish] = useState(false);
  const [showPresaleForm, setShowPresaleForm] = useState(false);
  const [hideStartMintingDetails, setHideStartMintingDetails] = useState(false);
  const FOURTY_FOUR_DAYS_IN_MS = 44 * 24 * 60 * 60 * 1000;
  const NOW_IN_MS = new Date().getTime();

  const launchDate = NOW_IN_MS + FOURTY_FOUR_DAYS_IN_MS;

  return (
    // <div className="w-full min-h-[100vh] md:min-h-[100vh] bg-[#B6C0E8] ">
    <div className="w-full relative  bg-[#0A0912] h-full  mt-0 min-h-[100vh] ">
      <Link
        to="/"
        className="text-[#646AFB] absolute top-0 z-[11] hover:text-[#fb64e2]  mt-[180px] left-[-30px] flex items-center px-40"
      >
        {" "}
        <IoIosArrowBack size={16} /> Home
      </Link>

      <div className=" w-full mt-[-150px] ">
        <div className="flex flex-col relative lg:flex-row  md:mt-0 justify-around md:px-[50px]">
          <div className="md:w-2/3  flex justify-center">
            <img
              className="w-5/12 2xl:w-4/12 z-10 3xl:w-3/12 3xl:top-40 lg:block absolute left-0 top-20 hidden  mt-10 "
              src={img}
              alt=""
            />

            <img
              className="w-full object-cover absolute z-0 left-0 top-0 bottom-0 h-full right-0"
              src={bg}
              alt=""
            />
          </div>

          <PresaleCountdown targetDate={launchDate} />
        </div>
      </div>
    </div>
  );
}

export default SpaceshipMint;
